import React from 'react';
import { fileName, fileUrl } from '../../../../../util/file_url';
import axios from 'axios';

export default class PDFDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false, 
      pdf: null,
    };
  }

  componentDidMount = async () => {
    console.log(`PDFDisplay mounted for filename: ${this.props.filename}`);
    this.setState({ isLoading: true });
    try {
      const fileURL = await this.getFileURL();
      console.log(`componentDidMount - fileURL result:`, fileURL ? 'Success' : 'Failed/Null');
      this.setState({ pdf: fileURL, isLoading: false });
    } catch (error) {
      console.error("Error loading PDF in componentDidMount:", error);
      this.setState({ isLoading: false, pdf: null });
    }
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.filename !== this.props.filename) {
      console.log(`PDFDisplay updated - filename changed from ${prevProps.filename} to ${this.props.filename}`);
      
      // Clean up previous Blob URL to prevent memory leaks
      if (this.state.pdf && this.state.pdf.startsWith('blob:')) {
        URL.revokeObjectURL(this.state.pdf);
      }
      
      this.setState({ isLoading: true, pdf: null }); // Reset pdf when filename changes
      try {
        const fileURL = await this.getFileURL();
        console.log(`componentDidUpdate - fileURL result:`, fileURL ? 'Success' : 'Failed/Null');
        this.setState({ pdf: fileURL, isLoading: false });
      } catch (error) {
        console.error("Error loading PDF in componentDidUpdate:", error);
        this.setState({ isLoading: false, pdf: null });
      }
    }
  }

  componentWillUnmount() {
    // Clean up Blob URL when component unmounts to prevent memory leaks
    if (this.state.pdf && this.state.pdf.startsWith('blob:')) {
      URL.revokeObjectURL(this.state.pdf);
    }
  }

  getFileURL = async () => {
    if (!this.props.filename) {
      console.warn("getFileURL called with no filename");
      return null;
    }
    
    console.log(`Fetching PDF: ${this.props.filename}`);
    
    try {
      let response = await axios.get(
        fileUrl(this.props.filename),
        { responseType: "arraybuffer" }
      );
      
      // Add detailed response logging
      console.log(`Response for ${this.props.filename}:`, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        dataLength: response.data ? response.data.byteLength : 'No data'
      });
      
      // Check if we actually got data
      if (!response.data || response.data.byteLength === 0) {
        console.error(`No data received for PDF: ${this.props.filename}`);
        return null;
      }
      
      console.log(`Creating Blob URL for ${response.data.byteLength} bytes for ${this.props.filename}`);
      
      // Use Blob URL instead of base64 data URL - much more efficient for large files
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      
      console.log(`Successfully generated Blob URL for ${this.props.filename}: ${fileURL}`);
      
      return fileURL;
      
    } catch (error) {
      console.error(`Error in getFileURL for ${this.props.filename}:`, {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error; // Re-throw to be caught by calling method
    }
  }

  render() {
    // console.log("Render src: ", this.state.pdf, "isLoading: ", this.state.isLoading);
    if (this.state.isLoading) {
      return <div>Loading PDF...</div>;
    }

    return this.state.pdf ? (
      <iframe
        key={this.state.pdf} // Key helps ensure iframe re-renders
        title={fileName(this.props.filename)}
        src={this.state.pdf}
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    ) : (
      <div>No PDF to display or failed to load.</div>
    );
  }
}
